import { useRef, useState } from 'react';
import axios from 'axios';
import { Building2, Save, Upload } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../lib/format';

export function ProfileSettings({ profile, onSaved }) {
  const [form, setForm] = useState({ company_name: profile.company_name, owner_name: profile.owner_name, title: profile.title });
  const [error, setError] = useState('');
  const submit = async (e) => {
    e.preventDefault(); setError('');
    try { await axios.put(`${API}/settings/profile`, form); toast.success('İşletme profili güncellendi'); onSaved(); }
    catch (err) { setError(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'Profil kaydedilemedi'); }
  };
  return <div className="panel form-card check-form" data-testid="profile-settings-panel">
    <div className="panel-head"><div><p className="eyebrow">İŞLETME PROFİLİ</p><h2>Firma ve kullanıcı bilgileri</h2></div><Building2 size={22} color="#087f73" /></div>
    <form onSubmit={submit}>
      <label>Firma adı<input required maxLength={80} value={form.company_name} onChange={(e) => setForm({ ...form, company_name: e.target.value })} placeholder="Örn. Kuzey Kahve & Co." data-testid="profile-company-input" /></label>
      <div className="form-grid">
        <label>Ad soyad<input required maxLength={80} value={form.owner_name} onChange={(e) => setForm({ ...form, owner_name: e.target.value })} placeholder="Örn. Ahmet Kaya" data-testid="profile-owner-input" /></label>
        <label>Unvan<input maxLength={40} value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="Yönetici" data-testid="profile-title-input" /></label>
      </div>
      {error && <p className="error-text" data-testid="profile-error">{error}</p>}
      <button className="primary" data-testid="save-profile-button"><Save size={15} /> Profili kaydet</button>
    </form>
  </div>;
}

export function ImportButton({ onDone }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const body = new FormData(); body.append('file', file);
    const id = toast.loading('Excel aktarılıyor…');
    try {
      const { data } = await axios.post(`${API}/import/cari`, body);
      toast.success(`${data.imported_rows} yeni hareket aktarıldı`, { id, description: `${data.skipped_duplicates} tekrar atlandı · ${data.contacts_created} yeni cari · ${data.sheets.length} sayfa`, duration: 8000 });
      onDone();
    } catch (err) { toast.error('Aktarım başarısız', { id, description: typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'Dosya okunamadı. "CARİ ADI" başlıklı Excel yükleyin.' }); }
    finally { setBusy(false); if (ref.current) ref.current.value = ''; }
  };
  return <>
    <input ref={ref} type="file" accept=".xlsx,.xls" hidden onChange={(e) => upload(e.target.files?.[0])} data-testid="import-file-input" />
    <button type="button" className="secondary" disabled={busy} onClick={() => ref.current?.click()} data-testid="import-excel-button"><Upload size={15} /> {busy ? 'Aktarılıyor…' : "Excel'den aktar"}</button>
  </>;
}
